import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { filterOperators, booleanFilterOperators } from './../../../../constants';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { booleanCell } from '../cells/boolean-cell';

export const WarehouseColumns = (): GridColDef[] => {
  const translationPrefix = 'entities.warehouse';

  const { t } = useTranslation();
  return [
    {
      field: 'code',
      headerName: t(`global.code`),
      width: 250,
      filterOperators,
      renderCell: (params: GridRenderCellParams) => {
        const warehouse = params.row;
        return (
          <div>
            <Link to={`${warehouse.id}`}>
              <b className="text-secondary-500">{warehouse.code}</b>
            </Link>
          </div>
        );
      }
    },
    {
      field: 'fiscal',
      filterOperators: booleanFilterOperators,
      width: 50,
      headerName: t(`global.fiscal`),
      renderCell: booleanCell(t)
    },
    {
      field: 'description',
      filterOperators,
      width: 250,
      headerName: t(`global.description`)
    },
    {
      field: 'parent_code',
      width: 150,
      headerName: t(`entities.warehouse.parent`),
      filterOperators: filterOperators.filter(({ value }) => value === 'contains')
    },
    {
      field: 'laboratories',
      filterOperators,
      // sortable: false,
      width: 150,
      headerName: t(`global.laboratories`)
    },
    {
      field: 'locations',
      filterOperators,
      filterable: true,
      sortable: true,
      width: 150,
      headerName: t(`global.locations`)
    },
    {
      field: 'city',
      filterOperators,
      width: 150,
      headerName: t(`${translationPrefix}.city`)
    },
    {
      field: 'district',
      filterOperators,
      width: 100,
      headerName: t(`${translationPrefix}.district`)
    },
    {
      field: 'zip_code',
      filterOperators,
      width: 100,
      headerName: t(`${translationPrefix}.zip_code`)
    },
    {
      field: 'phone_number',
      filterOperators,
      width: 150,
      headerName: t(`${translationPrefix}.phone_number`)
    },
    {
      field: 'order_prefix',
      width: 150,
      filterOperators,
      // sortable: false,
      // filterable: false,
      headerName: t(`${translationPrefix}.order_prefix`)
    }
  ];
};
